export const isNullOrEmpty = (value) => (value === null || value === undefined || value === '');